// import './css/loading-bar.css';
import '@babel/polyfill';
import $ from 'jquery';
import './less/bootstrap.less';
import 'url-polyfill';
import './react';

window.$ = $;
window.jQuery = $;
window.APP_VERSION = __VERSION__
console.log('appVersion: ', __VERSION__);
